import { Injectable } from '@angular/core';
import { EndSessionConfigurationService } from '../configuration/auth/logout/end-session/end-session-configuration.service';
import { ConfigurationService } from '../configuration/configuration.service';
import { AuthModule } from './auth.module';
import { AuthorityService } from './authority/authority.service';

@Injectable({
  providedIn: AuthModule
})
export class EndSessionService {

  get postLogoutRedirectUri() {
    return this.configuration.postLogoutRedirectUri;
  }

  path:any;

  get params() {
     return "post_logout_redirect_uri=" + encodeURIComponent(this.postLogoutRedirectUri);
  }

  get enabled() {
    return this.configuration.enabled;
  }

  get configuration() {
    return this.endSessionConfigurationService.configuration;
  }

  constructor(private endSessionConfigurationService: EndSessionConfigurationService,
     private authorityService: AuthorityService,
     private configurationService:ConfigurationService
     ) { 
      
     }

  endSession() {   
       this.path=this.configurationService.configuration.endSessionUrl;
       window.location.href = this.configurationService.configuration.endSessionUrl;;
  }

  createEndSessionUrl() {
    return this.authorityService.createResourceUrl(this.path);
  }
}
